module.exports = "/_next/static/images/Hero@2x-de976956e5dbd23f8c503d613ffbadb8.png";